import Link from 'ageas-react-component-link'
import TextField from 'ageas-react-component-textfield'

import { useEffect, useState } from 'react'
import { AddressDetails } from '../../../@types/ValidateZipCode'
import { MainContainer } from '../../../GlobalStyles'
import { t } from '../../../i18n'
import { filterAddresses } from '../../../utils/validates'
import { Cell, Header, Row, Table } from '../../TablePacks/styles'
import { ContainerAddressSelected } from '../style'

type SelectAddressProps = {
  data: AddressDetails[]
  onSelectedAddress: (address: AddressDetails) => void
}

export const SelectAddress = ({
  data,
  onSelectedAddress,
}: SelectAddressProps) => {
  const [dataFiltered, setDataFiltered] = useState(data)
  const [searchValue, setSearchValue] = useState('')

  const handleSearch = () => {
    if (searchValue) {
      setDataFiltered(filterAddresses(data, searchValue))
    }
  }

  useEffect(() => {
    if (searchValue === '') {
      setDataFiltered(data)
    }
  }, [searchValue, data])

  return (
    <MainContainer>
      <ContainerAddressSelected>
        <div className="search-container">
          <p>{t('addressSelectTable.searchTitle')}</p>
          <TextField
            isSearch
            id="searchAddress"
            label={t('addressSelectTable.search')}
            onValueChanged={(id: string, value: string) => {
              setSearchValue(value)
            }}
            colorTheme="blue"
            version="2"
            value={searchValue}
            onClick={() => {
              handleSearch()
            }}
          />
        </div>
        <Table>
          <thead>
            <Row>
              <Header>{t('addressSelectTable.address')}</Header>
              <Header>{t('addressSelectTable.location')}</Header>
            </Row>
          </thead>
          <tbody>
            {(dataFiltered || [])?.map((item, index) => (
              <Row key={index}>
                <Cell>
                  <div className="truncate">
                    <div className="button-link">
                      <Link
                        userCardDetailLink
                        noPaddingTopBottom
                        label={
                          item?.address || t('addressSelectTable.streetEmpty')
                        }
                        onValueChanged={() => onSelectedAddress(item)}
                      />
                    </div>
                  </div>
                </Cell>
                <Cell>{item?.town}</Cell>
              </Row>
            ))}
          </tbody>
        </Table>
        {(dataFiltered || [])?.length === 0 && (
          <div className="search-container">
            <p>{t('addressSelectTable.searchEmpty')}</p>
          </div>
        )}
      </ContainerAddressSelected>
    </MainContainer>
  )
}
